import React from 'react';
import { Link } from 'react-router-dom';
import './ISO14064.css';

const ISO14064 = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">System Certification</div>
            <h1 className="page-title">ISO 14064 Carbon Footprint Verification</h1>
            <h2 className="page-subtitle">The First Step Towards a Sustainable Future: ISO 14064</h2>
            <div className="page-text-content">
              <p>
                ISO 14064 is an international standard that provides a framework for measuring, 
                reporting, and verifying greenhouse gas emissions of organizations. This standard 
                helps businesses understand their environmental impact and take steps towards 
                sustainability.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Importance of ISO 14064 Carbon Footprint Verification</h2>
            <div className="importance-list">
              <div className="importance-item">
                <h3 className="importance-title">1. Improving Environmental Performance</h3>
                <p className="importance-description">
                  ISO 14064 enables organizations to measure and monitor their greenhouse gas emissions, 
                  helping them identify areas for improvement and reduce their environmental impact.
                </p>
              </div>
              <div className="importance-item">
                <h3 className="importance-title">2. Sustainability Reporting</h3>
                <p className="importance-description">
                  The standard provides a reliable framework for organizations to report their carbon 
                  footprint transparently, meeting stakeholder expectations and regulatory requirements.
                </p>
              </div>
              <div className="importance-item">
                <h3 className="importance-title">3. Competitive Advantage</h3>
                <p className="importance-description">
                  Organizations that verify their carbon footprint through ISO 14064 demonstrate their 
                  commitment to sustainability, gaining a competitive edge in the market and building 
                  trust with customers and partners.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">ISO 14064 Carbon Footprint Verification Process</h2>
            <div className="process-list">
              <div className="process-item">
                <h3 className="process-title">1. Data Collection and Analysis</h3>
                <p className="process-description">
                  Organizations collect data on their greenhouse gas emissions from various sources, 
                  including energy consumption, transportation, and production processes. This data is 
                  analyzed according to ISO 14064 requirements.
                </p>
              </div>
              <div className="process-item">
                <h3 className="process-title">2. Reporting</h3>
                <p className="process-description">
                  A comprehensive carbon footprint report is prepared, documenting all emission sources, 
                  calculation methods, and results in accordance with ISO 14064 standards.
                </p>
              </div>
              <div className="process-item">
                <h3 className="process-title">3. Verification</h3>
                <p className="process-description">
                  An independent third-party verification body reviews the organization's carbon footprint 
                  report to ensure accuracy, completeness, and compliance with ISO 14064 requirements.
                </p>
              </div>
              <div className="process-item">
                <h3 className="process-title">4. Certification</h3>
                <p className="process-description">
                  Upon successful verification, organizations receive ISO 14064 certification, 
                  demonstrating their commitment to transparent and accurate carbon footprint reporting.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <div className="page-text-content">
              <p>
                As NQC (Nova Quality Certification Agency), we are here to help you build a sustainable 
                future. Contact us to learn more about ISO 14064 Carbon Footprint Verification and how 
                it can benefit your organization.
              </p>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default ISO14064;

